import React from 'react';
import { Box } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';

const TourInformationsSectionSkeleton = () => (
  <Box my={3}>
    <Skeleton variant="text" width="30%" height={30} />
    <Skeleton variant="text" width="80%" height={50} />
    <Skeleton variant="text" width="60%" height={30} />
    <Skeleton variant="text" width="100%" height={170} />
    <Skeleton variant="text" width="100px" height={60} />
  </Box>
);
export { TourInformationsSectionSkeleton };
